import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex);

const state = {
	totalTime: 10,
    gisfoodlist:[],
	phfoodlist:[],
    carbofoodlist1:[],
    carbofoodlist2:[],
    foodweights:[],
    dataHeight:[],
    dataWeight:[],
    dataInsulin:[]
};

for(var i = 0; i < 161; i++){
    state.dataWeight[i] = {
        text: 40 + (0.5 * i) + 'kg',
        value: 40 + (0.5 * i)
    }
}
for(var i = 0; i < 56; i++){
    state.dataHeight[i] = {
        text: 145 + (1 * i) + 'CM',
        value: 145 + (1 * i)
    }
}
for(var i = 0; i < 20; i++){
    state.foodweights[i] = {
        text: 5 + (5 * i) + 'g',
        value: 5 + (5 * i)
    }
}
for(var i = 0; i < 51; i++){
    state.dataInsulin[i] = {
        text:10 + i
    }
}
export default new Vuex.Store({
	state,
	mutations,
	actions
})


// WEBPACK FOOTER //
// ./src/store/index.js